//
// mutations
//
import * as time from '@/libs/time'
import init from './init'

export default {
  // 新規予約用に初期化する
  initBook (state, book) {
    state.rid = 0
    state.shopid = book.shopid

    if (book.allow) {
      state.allow = {
        begin: time.format('Y-m-d H:i:s', book.allow.begin),
        end: time.format('Y-m-d H:i:s', book.allow.end)
      }
    } else {
      state.allow = { ...init.allow }
    }

    if (book.period) {
      state.period = {
        begin: time.format('Y-m-d H:i:s', book.period.begin),
        end: time.format('Y-m-d H:i:s', book.period.end),
        optdays: book.period.optdays,
        insurancedays: book.period.insurancedays,
        insuranceTerm: book.period.insuranceTerm,
        hiseason: book.period.hiseason
      }
    } else {
      state.period = { ...init.period }
    }

    state.carid = book.carid
    state.options = book.options
    state.gears = book.gears
    state.locationid = 0
    state.pick = 0
    state.deli = 0
    state.insuranceid = book.insuranceid
    state.peoples = 1
    state.couponCode = ''
    state.note = ''
    state.charge = { ...init.charge }
  },

  // 予約IDを上書きする
  setReserveID (state, rid) {
    state.rid = rid
  },

  // 予約可能期間を設定する
  setBookAllow (state, allow) {
    state.allow = {
      begin: time.format('Y-m-d H:i:s', allow.begin),
      end: time.format('Y-m-d H:i:s', allow.end)
    }
  },

  // 予約期間を設定する
  setBookPeriod (state, period) {
    state.period = {
      begin: time.format('Y-m-d H:i:s', period.begin),
      end: time.format('Y-m-d H:i:s', period.end),
      optdays: period.optdays,
      insurancedays: period.insurancedays,
      insuranceTerm: period.insuranceTerm,
      hiseason: period.hiseason || false
    }
  },

  // 車両を設定する
  setBookCarID (state, carid) {
    state.carid = carid
  },

  // オプションを個別に設定する
  setBookOption (state, opt) {
    state.options[opt.id] = opt.quantity - 0
  },

  // レンタルギアを個別に設定する
  setBookGear (state, opt) {
    state.gears[opt.id] = opt.quantity - 0
  },

  // 返却場所を設定する
  setLocationID (state, locationid) {
    state.locationid = locationid
  },

  // 送迎を設定する
  setBookPick (state, pick) {
    state.pick = pick
  },

  // 配車を設定する
  setBookDeli (state, deli) {
    state.deli = deli
  },

  // 免責を設定する
  setBookInsuranceID (state, insuranceid) {
    state.insuranceid = insuranceid
  },

  // 運転者数を設定する
  setBookPeoples (state, peoples) {
    state.peoples = peoples
  },

  // クーポンコードを設定する
  setBookCouponCode (state, couponCode) {
    state.couponCode = couponCode
  },

  // 連絡事項を設定する
  setBookNote (state, note) {
    state.note = note
  },

  // 支払方法を設定する
  setBookPayMethod (state, pay) {
    state.paymethod = pay.paymethod
    state.paytoken = pay.paytoken
  },

  // 基本料金を設定する
  setBookChargeBase (state, price) {
    state.charge.basic = price
  },

  // 追加料金を設定する
  setBookChargeAdditional (state, price) {
    state.charge.additional = price
  },

  // 割引料金を設定する
  setBookChargeDiscount (state, price) {
    state.charge.discount = price
  }
}
